<template>
  <div id="tab">
    <div class="left">
      <div class="tabs">
       
        <div class="lable">
          <i class="iconfont icon-kecheng"></i>
          精选课程
          <i class="el-icon-arrow-right"></i>
        </div>
       
        <div class="content-box">
          <el-row>
            <el-col
              class="content-col"
              :span="8"
              v-for="(item, index) in pageData['class_data']"
              :key="index"
            >
              <lemma :data="{ item }" type="3" v-if="index < 3"></lemma>
            </el-col>
          </el-row>
        </div>
      
      </div>
    </div>
    <div class="right">
      <ranking
        :id="'hot'"
        :icon="'icon-huaban'"
        :title="'学习排行榜'"
        :data="pageData.class_ranking_data"
        v-if="pageData.class_ranking_data"
      ></ranking>
    </div>
  </div>
</template>

<script>
import Lemma from "./Lemma.vue";
import Ranking from "./RankingClass.vue";

export default {
  name: "Tab",
  components: {
    Lemma,
    Ranking
  },
  props: {
    pageData: Object
  },
  data() {
    return {
     
    };
  },
  created() {
    
  },
  methods: {
   
  }
};
</script>
<style scope lang="scss">
#tab {
  width: 1200px;
  margin: 14px auto;
  border-radius: 2px;
  background-color: #ffffff;
  display: flex;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.11);
  .left {
    width: 940px;
    .tabs {
      .lable {
        font-size: 20px;
        color: #000000;
        // padding-left: 25px;
        z-index: 1;
        padding: 15px 0 15px 25px;
        border-bottom: 2px solid #e4e7ed;
        .iconfont {
          font-size: 20px;
          margin-right: 10px;
        }
        .icon-kecheng {
          font-size: 21px;
        }
        
      }

      .content-box {
        .content-col {
          box-sizing: border-box;
          position: relative;
        }
        .content-col:nth-child(4)::before {
          content: " ";
          width: 899px;
          height: 1px;
          background-color: #f5f5f5;
          position: absolute;
          left: 20px;
          top: 0;
        }
        .content-col:nth-child(3n-1)::before {
          content: " ";
          width: 1px;
          height: 280px;
          background-color: #f5f5f5;
          position: absolute;
          left: 0;
          top: 20px;
        }
        .content-col:nth-child(3n-1)::after {
          content: " ";
          width: 1px;
          height: 280px;
          background-color: #f5f5f5;
          position: absolute;
          right: 0;
          top: 20px;
        }
        .content-col_1:nth-child(3n-1)::before,
        .content-col_1:nth-child(3n-1)::after {
          height: 338px;
        }
      }
    }
  }
}
</style>
